// extracted by mini-css-extract-plugin
export default {"password-form":"UserModal_password-form__ATH64"};